
CheckoutV2.Payment.PriorAuth = function(checkout, payment, extra, isReview) {
	var priorauth = this;
	
	this.label = 'Prior Authorization';
	
	this.$wrap =
	this.$authNum =
	false;

    this.reviewSelector = '.';
    if (isReview)
       this.reviewSelector += 'review-';
	
	var getContainer = function() {
		return $(priorauth.reviewSelector + 'payment-method-priorauth-container');
	};
	
	this.init = function() {
		priorauth.getContainer = getContainer;
		
		priorauth.$wrap = $($.parseHTML(Jemplate.process('includes/partials/payment/priorAuth.html')));
		
		priorauth.$authNum = priorauth.$wrap.find('.payment-method-priorauth-num');
		priorauth.$amtInput = priorauth.$wrap.find('.payment-method-amount input');

        priorauth.$formFeedback = priorauth.$wrap.find('.js-form-feedback');

		priorauth.$loadingOverlay = priorauth.$wrap.find('.payment-loading-overlay');
		priorauth.$loadingMsg = priorauth.$loadingOverlay.find('.msg-text');
		priorauth.availableBalance = undefined;
		priorauth.priorAmount = undefined;
		priorauth.availableBalances = {};
		priorauth.authNumber = '';

		priorauth.debounceTimeout = null;
		priorauth.valid = false;
		priorauth.cartBalance = 0;
		priorauth.data = {
			authNum: null,
			cardType: null,
			amtInput: null
		};

        priorauth.$authNum.on('keyup keypress paste', function(e) {
        	var $that = $(this);

        	clearTimeout(priorauth.debounceTimeout);
            priorauth.debounceTimeout = setTimeout(function(){
                var newValue = $that.val();

                priorauth.valid = false;

                // No pre existing auth num has been entered, we have a pristine form field
                if(!priorauth.data.authNum && newValue === '') {
                    return false;
                }
                else if (newValue === '') { // Throw a field required error with a dirty form.
                    priorauth.$formFeedback.find('span').html("Authorization number is required");
                    priorauth.$formFeedback.show();
                    return false;
                }

                priorauth._getAuthData(newValue);
			}, 300);
		});
	};

	this._getAuthData = function(authNumber) {
        priorauth.$wrap.find('.js-form-loading').removeClass('hidden');
        $.ajax({
            url: '/Validate/AuthorizationNumber/'+authNumber,
            method: 'GET',
            dataType: 'json'
        })
            .done(function(result) {
				// Update the amount input value and amount data using the response balance
                priorauth.data.authNum = authNumber;
                if(result.method === 'paypal') {
                    priorauth.data.cardType = 'paypal';
				} else {
                    priorauth.data.cardType = result.cardType;
				}


                if(result.method === 'paypal') {
                    priorauth.$amtInput.val(result.balance);
                    priorauth.data.amtInput = result.balance;
                } else {
                    priorauth.$amtInput.val(priorauth.cartBalance);
                    priorauth.data.amtInput = priorauth.cartBalance;
				}

                priorauth.$wrap.find('.js-priorauth-order').html("");
                priorauth.$wrap.find('.js-priorauth-order').append('<div> Balance:: ' + priorauth.data.amtInput +'</div>');
                priorauth.$wrap.find('.js-priorauth-order').append('<div> Type:: ' + priorauth.data.cardType +'</div>');

                if(result.method === 'paypal' && result.balance < priorauth.cartBalance) {
                    priorauth.$formFeedback.find('span').html('Paypal balance can not be less than the current cart balance.');
                    priorauth.$formFeedback.show();
                    return;
                }

                priorauth.valid = true;
                priorauth.$formFeedback.find('span').html("");
                priorauth.$formFeedback.hide();
            })
            .fail(function(error) {
                if(error.status === 404){
                    priorauth.$formFeedback.find('span').html(error.responseJSON.message);
                    priorauth.$formFeedback.show();
                }
                priorauth.$wrap.find('.js-priorauth-order').html("");
                priorauth.$amtInput.val('0.00');
                priorauth.valid = false;
            })
            .always(function() {
                priorauth.$wrap.find('.js-form-loading').addClass('hidden');
                payment.reApplyBalances();
            });
	};

	this.buildReview = function() {
		var card = priorauth;
        return {
        	method: 'priorauth',
			method_name: card.label,
			payment_amount: checkout.payment.getMethodAmt( card )
		};
   	};


	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			priorauth.$loadingMsg.html(loadingMsg);
			priorauth.$loadingOverlay.show();
			checkout.alignMiddle(priorauth.$loadingOverlay.find('.msg'), priorauth.$loadingOverlay);
		} else
		priorauth.$loadingOverlay.hide();
	};
	
	this.afterChangeAmt = function(amount) {
        priorauth.cartBalance = amount;
        // Paypal needs to keep whatever its authed amount was.
		// Credit card methods use whatever the new amount value is.
        if(priorauth.data.cardType !== 'paypal') {
            priorauth.$amtInput.val(amount);
            priorauth.data.amtInput = amount;
		}
	};
	
	this.getData = function() {
		return priorauth.data;
	};

	this.setData = function(data) {
		priorauth.data = data;
	};
	
	this.validate = function() {
		return priorauth.valid;
	};
	
	
	this.fieldErrors = function(errors) {
	};
	
	this.init();
};

